import { ChangeDetectionStrategy, Component, DOCUMENT, Inject, OnInit } from '@angular/core';
import { environment } from '@environment';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'sb-access-denied-page',
    templateUrl: './access-denied-page.component.html',
    styleUrls: ['./access-denied-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class AccessDeniedPageComponent implements OnInit {
    constructor(
        private location: Location,
        private titleService: Title,
        private router: Router,
        private translateService: TranslateService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    ngOnInit() {
        this.setTitle(this.translateService.instant('Access denied'));

        // need to reset min-width: 1000px
        this.document.body.style.minWidth = 'unset';

        const subscription = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
            this.setTitle('Socialboards');
            subscription.unsubscribe();
        });
    }

    goToPreviousLink() {
        this.location.back();
    }

    login() {
        const redirectUrl = encodeURIComponent(window.location.href);
        window.location.href = environment.loginAppUrl + '?url=' + redirectUrl;
    }

    private setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
}
